<template>
  <page>
    <page-error :message="$t('ErrorPage_NotFound')" />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageError from '@/common/components/page/PageError'

export default {
  name: 'NotFoundPage',
  components: { PageError, Page }
}
</script>



// WEBPACK FOOTER //
// src/modules/errors/pages/NotFoundPage.vue